export class ProjectImpedimentModel {
    constructor() {
        this.impediments = "";
    }
}
export default class ProjectImpediment extends ProjectImpedimentModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
